<template>
  <div class="select">
    <div class="wrapper">
      <div class="container">
        <div class="left">
          <div class="content">
            <back-action />
            <h1>Voor welke sector wil je een subsidie aanvragen?</h1>
          </div>
        </div>
        <div class="right">
          <div class="content" id="main">
            <div class="inner">
              <div class="rows">
                <router-link to="/sector/po-vo" class="col">
                  <h2>Primair en voortgezet onderwijs</h2>
                  <button class="button">Maak keuze</button>
                </router-link>         
                <router-link to="/sector/mbo" class="col">
                  <h2>Middelbaar beroepsonderwijs</h2>
                  <button class="button">Maak keuze</button>
                </router-link>
                <router-link to="/sector/ho" class="col">
                  <h2>Hoger onderwijs</h2>
                  <button class="button">Maak keuze</button>
                </router-link>
                <router-link to="/sector/ve" class="col">
                  <h2>Volwasseneneducatie</h2>
                  <button class="button">Maak keuze</button>
                </router-link>
                <router-link to="/sector/jeugd" class="col">
                  <h2>Jeugd en jongerenwerk</h2>
                  <button class="button">Maak keuze</button>
                </router-link>
                <router-link to="/sector/sport" class="col">
                  <h2>Sport</h2>
                  <button class="button">Maak keuze</button>
                </router-link>
                <div class="col"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "sass:math";
@import "../../style/vars";

.select {
  .wrapper {
    .container {
      .right {
        .content {
          .inner {
            @media (min-width: $breakpoint-xl) {
              position: absolute;
              top: math.div($base-padding, 2);
              width: 100%;
              height: 100%;
              display: flex;
              flex-wrap: wrap;
              align-items: center;
              justify-content: center;
            }
          }
          .rows {
            margin: -$base-padding 0 0;
            @media (min-width: $breakpoint-lg) {
              display: flex;
              flex-wrap: wrap;
              //align-items: center;
              justify-content: center;
            }
            .col {
              display: flex;
              flex-wrap: wrap;
              align-items: flex-start;
              justify-content: center;
              flex-direction: column;
              text-decoration: none;
              padding: $base-padding;
              color: $text-select;
              background-color: $white;
              margin-bottom: math.div($base-padding, 2);
              min-height: 7rem;
              h2 {
                display: block;
                font-size: 1.375rem;
                line-height: 1.5625rem;
                font-family: "Roboto", sans-serif;
                font-weight: 400;
                @media (min-width: $breakpoint-lg) {
                  br {
                    display: none;
                  }
                }
              }
              .button {
                margin-top: math.div($base-padding, 2);
                @media (min-width: $breakpoint-xl) {
                  margin-top: $base-padding;
                }
                @media (min-width: $breakpoint-xxl) {
                  margin-top: ($base-padding * 1.5);
                }
              }
              @media (min-width: $breakpoint-lg) {
                width: math.div(100%, 2.5);
              }
              @media (min-width: $breakpoint-xl) {
                width: math.div(100%, 2.6);
              }
              @media (min-width: $breakpoint-xxl) {
                padding: ($base-padding * 1.25);
                width: math.div(100%, 2.7);
              }
              &:hover {
                .button {
                  background: $base-color-light;
                  outline: 0;
                  box-shadow: 0 0.125rem $base-color;
                  top: 0.125rem;
                  color: #fff;
                }
              }
            }
            .col:nth-child(1) {
              background-color: #ccebdc;
            }
            .col:nth-child(2) {
              background-color: #cce9f2;
            }
            .col:nth-child(3) {
              background-color: #d2e6e7;
            }
            .col:nth-child(4) {
              background-color: #f9e1d7;
            }
            .col:nth-child(5) {
              background-color: #f7d7e4;
            }
            .col:nth-child(6) {
              background-color: #DCF5DB;
            }
            .col:nth-child(odd) {
              @media (min-width: $breakpoint-lg) {
                margin-right: math.div($base-padding, 4);
              }
            }
            .col:nth-child(even) {
              @media (min-width: $breakpoint-lg) {
                margin-left: math.div($base-padding, 4);
              }
            }
            .col:last-child {
              overflow: hidden;
              opacity: 0;
              height: 0px;
              min-height: 0px;
              padding: 0;
              @media (min-width: $breakpoint-lg) {
                width: math.div(100%, 2.5);
                padding: $base-padding;
              }
              @media (min-width: $breakpoint-xl) {
                width: math.div(100%, 2.6);
              }
              @media (min-width: $breakpoint-xxl) {
                padding: ($base-padding * 1.25);
                width: math.div(100%, 2.7);
              }
            }
          }
        }
      }
    }
  }
}
</style>
